export default __webpack_public_path__ + "static/media/facebook.57e03684.webp";